import React from 'react';
import Toolbar from 'components/common/Toolbar';
import ToolbarGroup from 'components/common/Toolbar/Group';
import { Input, Button, Row, Col, Tooltip } from 'antd';
import MaterialIcon from 'components/common/MaterialIcon';
import PropTypes from 'prop-types';
import TreeView from '../TreeView';
import Avatar from '../Avatar';
import v1uuid from 'uuid/v1';
// import 'assets/js/jquery-ui-1.10.2.custom.min';
import 'assets/js/primitives.min';
// import 'assets/js/bporgeditor.min';
import 'assets/app/primitives.css';

@autobind
/**
 *
 */
export default class PrimitiveCharts2 extends React.PureComponent {
  static propTypes = {
    items: PropTypes.array,
    buttons: PropTypes.array,
    hasButtons: PropTypes.bool,
    selectable: PropTypes.bool,
    showAllCheckboxes: PropTypes.bool,
    onButtonClick: PropTypes.func,
    onSelectionChanged: PropTypes.func,
    onCursorChanged: PropTypes.func,
    cursorItem: PropTypes.number,
    selected: PropTypes.array,
  };

  static defaultProps = {
    items: [],
    buttons: [],
    hasButtons: true,
    selectable: true,
    showAllCheckboxes: true,
    selected: [],
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.searchInputId = v1uuid();
    this.state = {
      selected: props.selected,
      selectedItem: [],

      searchValue: null,
      matchedSearch: [],
      found: 0,
      onScale: 1,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      items, hasButtons, buttons, onButtonClick, selectable, showAllCheckboxes,
      onSelectionChanged, onCursorChanged, cursorItem,
    } = this.props;
  }


  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
  }

  /**
   *permissions
   * @return {Array}
   * @private
   */
  _renderTreeData(parent = null) {
    const { items } = this.props;
    let _items = [];
   console.log("itemitemss",items);
   
    items.map((item) => {
      if (item.parent === parent) {
        _items.push({
          id: item.id,
          title: item.title,
          active: item.active,
          description: item.description,
          parent: item.parent,
          personnelId: item.personnelId,
          templateName: item.templateName,
          children: this._renderTreeData(item.id),
        });
      }
    });

    return _items;
  }


  /**
   *
   * @return {Array}
   */
  get selected() {
    return this.state.selected;
  }

  /**
   *
   * @return {Array}
   */
  get items() {
    return this.state.selectedItem;
  }


  _renderSelected(selected = []) {
    let item;
    const { onButtonClick, hasButtons } = this.props;

    item = this.props.items && this.props.items.find((_item) => _item.id === parseInt(selected[0]));

    let data = { name: '', context: item };

    return (
      <div className='treeChart'>
        {item && hasButtons ?
          <div className='tools'>
            <Tooltip
              placement="bottomRight"
              title={app.translate('main.Add')}
            >
              <div className='actionIcon' onClick={(e) => onButtonClick(e, Object.assign({}, data, { name: 'add' }))}>
                <MaterialIcon name='plus' />
              </div>
            </Tooltip>
            <Tooltip
              placement="bottomRight"
              title={app.translate('main.Edit')}
            >
              <div className='actionIcon' onClick={(e) => onButtonClick(e, Object.assign({}, data, { name: 'edit' }))}>
                <MaterialIcon name='pencil' />
              </div>
            </Tooltip>
            <Tooltip
              placement="bottomRight"
              title={app.translate('main.Delete')}
            >
              <div className='actionIcon' onClick={(e) => onButtonClick(e, Object.assign({}, data, { name: 'delete' }))}>
                <MaterialIcon name='delete' />
              </div>
            </Tooltip>
            <Tooltip
              placement="bottomRight"
              title={app.translate('main.Move')}
            >
              <div className='actionIcon' onClick={(e) => onButtonClick(e, Object.assign({}, data, { name: 'move' }))}>
                <MaterialIcon name='arrow-all' />
              </div>
            </Tooltip>
          </div>
          :
          <div className='tools'>
            <div />
            <div />
            <div />
            <div />
          </div>
        }
        {item ?
          <Avatar
            style={{
              float: 'right',
              background: '#f2f2f2',
              margin: '7px 3px',
            }}
            src={item && item.src}
            text={item && item.title}
            size='large'
          /> :
          <div
            className='Avatar' />
        }
        <div className='userData'>
          <div
            className='box'
            style={{
              width: '286px',
            }}>
            {item && item.title}
          </div>

          {item ?
            <Tooltip
              placement="bottomRight"
              title={app.translate(`main.${item.templateName}`)}
            >
              <div className='actionIcon'>{
                <MaterialIcon
                  style={{
                    color: item && item.templateName === 'post' ? '#e74c3c' : '#3c4ce7',
                  }}
                  name={item && item.templateName ? item.templateName === 'post' ? 'account' : 'file-tree' : ''} />
              }</div>
            </Tooltip> :
            <div className='actionIcon' />
          }
          <div style={{ clear: 'both', width: 0, height: 0, padding: 0, margin: 0 }} />
          <div
            className='box'
            style={{
              width: '180px',
            }}>
            {item && item.description}
          </div>

          <div
            className='box'
            style={{
              width: '100px',
              direction: 'ltr',
            }}>
            {item && item.personnelId}
          </div>
          {item && item.active !== undefined ?
            <Tooltip
              placement="bottomRight"
              title={app.translate('main.Status')}
            >
              <div
                className='actionIcon'
                style={{
                  background: item && item.active !== undefined ? item.active === true || item.active === 1 ? 'green' : 'red' : '#f2f2f2',
                }}>{
                  <MaterialIcon style={{
                    color: '#fff',
                  }} name={item && item.active !== undefined ? item.active === true || item.active === 1 ? 'check' : 'close' : ''} />
                }</div>
            </Tooltip> :
            <div
              className='actionIcon'
              style={{
                background: '#f2f2f2',
              }} />
          }
        </div>
        <div style={{ clear: 'both', width: 0, height: 0, padding: 0, margin: 0 }} />
      </div>);
  }


  _renderTreeItem(items) {
    items.map((item) => {
      if (item.children) {
        return (
          <Tree.TreeNode key={item.key} title={title}>
            {this._renderTreeItem(item.children)}
          </Tree.TreeNode>
        );
      }
      return <Tree.TreeNode key={item.key} title={title} />;
    });
  }

  /**
   * 
   * @param {*} _value 
   */
  fa2en(_value) {
    let value = _value;
    value = value.replace(/[۰]/g, '0');
    value = value.replace(/[۱]/g, '1');
    value = value.replace(/[۲]/g, '2');
    value = value.replace(/[۳]/g, '3');
    value = value.replace(/[۴]/g, '4');
    value = value.replace(/[۵]/g, '5');
    value = value.replace(/[۶]/g, '6');
    value = value.replace(/[۷]/g, '7');
    value = value.replace(/[۸]/g, '8');
    value = value.replace(/[۹]/g, '9');
    return value;
  }
  /**
   *
   * @param {String} value
   */
  onSearch(value) {
    if (value) {
      const { searchValue } = this.state;
      const { items } = this.props;
      let _matched = [];
      let _value = app.persianJs(value).arabicChar().toString();
      let en_value = this.fa2en(value);

      if (searchValue !== _value) {
        if (_value.length > 0) {
          items.map((item) => {
            if ((_matched.indexOf(item.id) < 0)
              && ((item.title
                && item.title.length > 0
                && item.title.search(_value) >= 0)
                || (item.description
                  && item.description.length > 0
                  && item.description.search(_value) >= 0)
                || (item.personnelId
                  && item.personnelId.length > 0
                  && item.personnelId.search(en_value) >= 0))) {
              // TODO personnel code search
              _matched.push(item.id);
            }
          });
        }

        this.setState({
          found: -1,
          searchValue: _value,
          matchedSearch: _matched,
        }, () => this.getNextMatchedSearch());
      } else {
        this.getNextMatchedSearch();
      }
    } else {
      this.setState({
        searchValue: '',
        matchedSearch: [],
      }, () => this.getNextMatchedSearch());
    }
  }

  /**
   *
   */
  getNextMatchedSearch() {
    const { matchedSearch, found } = this.state;

    let _index = found; //matchedSearch.indexOf(this.props.items);

    if (_index > -1 && _index === matchedSearch.length - 1) {
      _index = -1;
    }

    if (_index < matchedSearch.length - 1) {
      this.setState({ found: (_index + 1), selectedItem: [`${matchedSearch[_index + 1]}`] });
    }
  }
  /**
   * 
   */
  getPrevMatchedSearch() {
    const { matchedSearch, found } = this.state;

    let _index = found; //matchedSearch.indexOf(this.props.items);

    if (_index === 0 && matchedSearch.length !== 0) {
      _index = matchedSearch.length;
    }

    if (_index > 0) {
      this.setState({ found: (_index - 1), selectedItem: [`${matchedSearch[_index - 1]}`] });
    }
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { searchValue, matchedSearch, onScale, found, selectedItem, selected } = this.state;
    const { items, selectable } = this.props;


    console.log(this.state, this.props);

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          //   height: (document.body.scrollHeight - 140),
        }}
        className="chart"
      >
        <Toolbar>
          <ToolbarGroup>
            <Input.Search
              placeholder={app.translate('main.Search')}
              style={{
                width: 200,
                WebkitMarginEnd: 8,
              }}
              onChange={(e) => this.onSearch(e.target.value)}
              onSearch={this.onSearch}
              id={`${this.searchInputId}`}
            />
            <Button.Group>
              <Button
                onClick={this.getNextMatchedSearch}
                type="primary"
                disabled={!(searchValue && matchedSearch.length > 1)}
                style={{
                  paddingLeft: 8,
                  height: 32,
                }}
              >
                <MaterialIcon name="chevron-left" size="tiny" />
              </Button>
              <Button
                onClick={this.getPrevMatchedSearch}
                type="primary"
                disabled={!(searchValue && matchedSearch.length > 1)}
                style={{
                  paddingRight: 8,
                  height: 32,
                }}
              >
                <MaterialIcon name="chevron-right" size="tiny" />
              </Button>
            </Button.Group>

            {
              searchValue && searchValue.length > 0 &&
              <span style={{
                padding: '7px',
              }}>{app.translate('main.Search results')} : {matchedSearch.length} {(matchedSearch.length > 0) ? ` / ${found + 1}` : ``}</span>
            }
          </ToolbarGroup>
        </Toolbar>

        <div
          ref={(input) => this.chart = input}
          style={{
            width: '100%',
            background: '#ffffff',
            height: 'calc(100% - 68px)',
            paddingBottom: '50px',
            //   height: (document.body.scrollHeight - 140 - 48),
          }}
        >

          {this._renderSelected(selectedItem)}

          <TreeView
            checkable={selectable}
            onCheck={(selected) => this.setState({ selected: selected })}
            defaultCheckedKeys={app._.isEmpty(selectedItem) ? selected : selectedItem}
            expandedKeys={app._.isEmpty(selectedItem) ? selected : selectedItem}
            treeData={this._renderTreeData(null)}
            onSelect={(selected) => {
              const { onCursorChanged } = this.props;
              this.setState({ selectedItem: selected }, () => {
                if (selected[0] && onCursorChanged) {
                  onCursorChanged(null, { context: { id: parseInt(selected[0]) } });
                }
              });
            }}
            renderItem={(title, item) => {
              return (<span style={{
                color: `${item.id}`=== `${selectedItem && selectedItem[0]}` ? '#339933' : '#333333',
                background: `${item.id}`=== `${selectedItem && selectedItem[0]}` ? '#ffff9c' : '#ffffff',
              }}>
                <MaterialIcon
                  style={{
                    color: item.templateName === 'post' ? '#e74c3c' : '#3c4ce7',
                  }}
                  name={item.templateName === 'post' ? 'account' : 'file-tree'}
                /> {item.title}{
                  item.templateName === 'post' ? ` ( ${item.description} ) ` : ''
                }</span>);
            }
            }
          />
        </div>

      </div>
    );
  }
}
